<template>
	<div class="center_collection_box">
		<!-- 标题 -->
		<center-title>{{$t("message.ccoll.title")}}</center-title>
		<!-- 内容区域 -->
		<div class="center_collection_content">
			<!-- 多选 & 搜索框 -->
			<div class="center_collection_multiple_search">
				<!-- 批量 -->
				<el-button size="mini" @click="visible = true">
					<span>{{$t("message.ccoll.search4")}}</span>
				</el-button>
				<!-- 搜索框 -->
				<div class="center_collection_search">
					<el-input size="mini" v-model="search" :placeholder="$t('message.ccoll.place')"
						@blur="searchCollection" @keyup.13.native="searchCollection">
						<i slot="suffix" class="el-input__icon el-icon-search"></i>
					</el-input>
				</div>
			</div>
			<!-- 标签页部分 -->
			<el-tabs @tab-click="nowType()" v-model="type">
				<el-tab-pane :label="$t('message.ccoll.homePageCollection')"
					v-if="power.includes(111) || power.includes(17) || power.includes(0)">
				</el-tab-pane>
				<el-tab-pane :label="$t('message.ccoll.myFavorite')"
					v-if="!power.includes(111) && (power.includes(24) || power.includes(0))">
				</el-tab-pane>
			</el-tabs>
			<!-- 商品部分 -->
			<el-row :gutter="20" v-if="collection_goods&&collection_goods.length>0">
				<el-col :span="6" v-for="(item,index) in collection_goods" :key="index">
					<div class="center_collection_goods_box">
						<center-goods-list :goods="item">
						</center-goods-list>
					</div>
				</el-col>
			</el-row>
			<div class="center_collection_content_nothing" v-else>
				{{$t("message.ccoll.nothing")}}
			</div>
			<!-- 分页器 -->
			<div class="center_collection_content_pagination">
				<!-- <el-pagination 
				    layout="prev, pager, next" 
					:current-page="currentPage" 
					:page-count="pageCount"
					@current-change="handlePage" 
					background>
				</el-pagination> -->
				<el-pagination @current-change="handlePage" :current-page.sync="currentPage2"
					:page-size="goods_per_page" layout="prev, pager, next, jumper" :total="goods_total" background>
				</el-pagination>
			</div>
		</div>
		<!-- 属性选择模态框 -->
		<get-attr></get-attr>
		<collect-dialog :visible-dialog="visible" :table-data="collection_goods" @handle-close="visible = false"
			@handle-cart="(arg) => handleBatch(arg, 1)" @handle-qcart="(arg) => handleBatch(arg, 2)"
			@handle-collect="(arg) => handleBatch(arg, 3)">
		</collect-dialog>
	</div>
</template>

<script>
	import {
		mapState,
		mapMutations,
		mapActions
	} from "vuex";

	export default {
		data() {
			return {
				type: 0,
				currentPage2: 0,
				search: "", // 搜索框绑定值
				visible: false
			}
		},
		computed: mapState({
			islogin: state => state.user.islogin,
			user_id: state => state.user.user_id,
			collection_goods: state => state.goods.collection_goods,
			currentPage: state => state.goods.currentPage,
			pageCount: state => state.goods.pageCount,
			power: state => state.user.power,
			goods_per_page: state => state.goods.goods_per_page,
			goods_total: state => state.goods.goods_total,

		}),
		components: {
			centerTitle: () => import("@/components/center/centerTitle"),
			centerGoodsList: () => import("@/components/center/centerGoodsList"),
			collectDialog: () => import("@/components/center/collect-dialog"),
			getAttr: () => import("@/components/getAttr"),
		},
		watch: {
			currentPage() {
				this.currentPage2 = this.currentPage
			}
		},
		methods: {
			...mapMutations([
				"setCollection",
				'handleLoading'
			]),
			...mapActions([
				"getCollection",
				'handleCollectBatch',
				'getQuoteCart',
				'getCart'
			]),
			//選擇不同的類型
			nowType() {
				this.getCollection({
					page: 1,
					search: this.search,
					type: Number(this.type) + 1,
					power: this.power.includes(111),
				}).then(res => {

				})
			},
			searchCollection() { // 搜索框
				this.getCollection({
					page: 1,
					search: this.search,
					type: Number(this.type) + 1,
					power: this.power.includes(111),
				}).then(res => {

				})
			},
			handlePage(val) { // 分页器
				this.getCollection({
					page: val,
					search: this.search,
					type: Number(this.type) + 1,
					power: this.power.includes(111),
				}).then(res => {

				})
			},
			handleBatch(selection, type) {
				let url = '',
					params = '',
					collection_id = [];

				if (selection.length == 0) {
					this.$message({
						showClose: true,
						message: '您还没有选择商品',
						type: 'warning'
					})
					return;
				}

				switch (type) {
					case 1: // 购物车
						url = '/index/collection/add_cart_all';
						params = this.$qs.stringify({
							data: selection,
						});
						for (let item of selection) {
							if (item.attr.length > 0 && item.goods_attr_id === '') {
								this.$message({
									showClose: true,
									message: `商品-- ${item.goods_name} --未选择颜色属性`,
									type: 'warning'
								})
								return;
							} else if (item.attr2.length > 0 && item.goods_specification_id === '') {
								this.$message({
									showClose: true,
									message: `商品-- ${item.goods_name} --未选择规格属性`,
									type: 'warning'
								})
								return;
							}
						}
						break;
					case 2: // 报价车
						url = '/index/collection/add_quote_all';
						params = this.$qs.stringify({
							data: selection,
						});
						for (let item of selection) {
							if (item.attr.length > 0 && item.goods_attr_id === '') {
								this.$message({
									showClose: true,
									message: `商品-- ${item.goods_name} --未选择颜色属性`,
									type: 'warning'
								})
								return;
							} else if (item.attr2.length > 0 && item.goods_specification_id === '') {
								this.$message({
									showClose: true,
									message: `商品-- ${item.goods_name} --未选择规格属性`,
									type: 'warning'
								})
								return;
							}
						}
						break;
					case 3: // 取消收藏
						url = '/index/collection/delete';
						selection.map(item => {
							collection_id.push(item.collection_id);
						})
						params = this.$qs.stringify({
							collection_id
						})
						break;
				}

				this.handleLoading(true);
				this.handleCollectBatch({
					url,
					params
				}).then(res => {
					let code = res.data.code;
					switch (type) {
						case 1:
							if (code == 1) {
								this.visible = false;
								this.$message({
									showClose: true,
									message: '加入成功！',
									type: 'success'
								})

								this.getCart();
							} else if (code == 404) {
								this.visible = false;
								this.$message({
									showClose: true,
									message: '您的登录有效期已过期，请重新登录后再操作！',
									type: 'error'
								})
							}
							else if (code == 5) {
								this.visible = false;
								this.$message({
									showClose: true,
									message: '您還沒有權限購買此商品，請聯繫管理員！',
									type: 'error'
								})
							}
							else if (code == 2) {
								this.visible = false;
								this.$message({
									showClose: true,
									message: '暂时缺货',
									type: 'error'
								})
							}
							break;
						case 2:
							if (code == 1) {
								this.visible = false;
								this.$message({
									showClose: true,
									message: '加入成功！',
									type: 'success'
								})

								this.getQuoteCart();
							} else if (code == 404) {
								this.visible = false;
								this.$message({
									showClose: true,
									message: '您的登录有效期已过期，请重新登录后再操作！',
									type: 'error'
								})
							}
							break;
						case 3:
							if (code == 1) {
								this.$message({
									showClose: true,
									message: this.$t("public.delSucc"),
									type: "success"
								})
								this.visible = false;
								this.getCollection({
									page: this.currentPage,
									search: this.search,
									type: Number(this.type) + 1,
									power: this.power.includes(111),
								}).then(res => {

								})
							}
							break;
						
					}
				}).catch(err => {
					alert(`删除收藏接口异常：${err}，请联系管理员`);
				}).finally(() => {
					this.handleLoading(false);
				})
			}
		},
		beforeRouteEnter(to, from, next) {
			next(vm => {
				setTimeout(() => {
					let allow = vm.power.includes(0) || vm.power.includes(17) || vm.power.includes(111) ||
						vm.power.includes(24);
					if (!allow) {
						vm.$router.back();
						return false;
					} else {
						let type = 1
						if (!vm.power.includes(17) && vm.power.includes(24)) {
							type = 2
						}
						vm.getCollection({
							page: vm.currentPage,
							search: "",
							type,
							power: vm.power.includes(111),
						}).then(res => {

						})
					}
				}, 500)
			})
		},
		beforeRouteLeave(to, from, next) {
			this.setCollection(false);
			next();
		}
	}
</script>

<style scoped>
	/* 内容区域 */
	.center_collection_content {
		padding: 20px;
		background: #fff;
	}

	/* 暂无商品 */
	.center_collection_content_nothing {
		padding: 200px 0;
		text-align: center;
		color: #909399
	}

	/* 多选 & 搜索区域 */
	.center_collection_multiple_search {
		text-align: right;
	}

	.center_collection_multiple_search>div {
		display: inline-block;
		margin-left: 50px;
	}

	/* 商品框 */
	.center_collection_goods_box {
		position: relative;
		margin-bottom: 5px;
	}

	/* 打开多选时 */
	.center_collection_goods_batch {
		position: absolute;
		top: 0;
		left: 0;
		display: block;
		width: 100%;
		height: 100%;
		color: #909399;
		background-color: #E4E7ED80;
		border: 1px solid #909399;
		z-index: 100;
	}

	/* 选中 */
	.center_collection_goods_batch_select {
		color: #ff6700;
		border-color: #ff6700;
	}

	/* 图标 */
	.center_collection_goods_batch>i {
		margin: 10px;
		font-size: 30px;
	}

	/* 分页器 */
	.center_collection_content_pagination {
		margin: 20px 0;
		text-align: right;
	}
</style>
